namespace Serenity.Extensions {
    export interface ExcelImportRequest extends Serenity.ServiceRequest {
        FileName?: string;
    }
}
